<template>
  <form @submit.prevent="submitForm">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12">
        <label for="projectName">Project Name</label>
        <InputText id="projectName" type="text" v-model="project.name" />
      </div>

      <div class="p-field p-col-12 p-md-6">
        <label for="budget">Budget</label>
        <InputNumber
          id="budget"
          v-model="project.budget"
          mode="currency"
          currency="EUR"
          locale="fr-FR"
          :maxFractionDigits="2"
          :minFractionDigits="1"
          :min="0"
        />
      </div>

      <div class="p-field p-col-12 p-md-6">
        <label for="surface">Surface Area</label>
        <InputNumber
          id="surface"
          v-model="project.surface"
          :maxFractionDigits="2"
          :minFractionDigits="1"
          :min="0"
          suffix=" m²"
        />
      </div>

      <div class="p-field p-col-12 p-md-6">
        <label for="work-type">Work Type</label>
        <SelectButton
          id="work-type"
          class="p-text-capitalize"
          v-model="project.workType"
          :options="workTypes"
        />
      </div>

      <div class="p-field p-col-12 p-md-6">
        <label for="work-state">Work State</label>
        <SelectButton
          id="work-state"
          class="p-text-capitalize"
          v-model="project.workState"
          :options="workStates"
        />
      </div>

      <div class="p-field p-col-12">
        <label for="address">Address</label>
        <autocomplete-maps
          id="address"
          @place-changed="setLocation"
        ></autocomplete-maps>
      </div>

      <div class="p-field p-col-12">
        <label for="notes">Notes</label>
        <Textarea
          id="notes"
          v-model="project.notes"
          :autoResize="true"
          rows="2"
          cols="30"
        />
      </div>
    </div>
    <Button label="Save Project" type="submit" class="p-mt-3" />
  </form>
</template>

<script>
import { reactive } from "vue";
import { useMaps } from "../../composables/useMaps.js";
import AutocompleteMaps from "../AutocompleteMaps.vue";

export default {
  emits: ["form-submitted"],
  components: {
    AutocompleteMaps
  },
  setup(_props, context) {
    const project = reactive({
      name: "",
      location: null,
      workType: "",
      workState: "",
      budget: null,
      surface: null,
      notes: "",
      coverUrl: "",
      clientId: ""
    });

    const workTypes = ["interior", "exterior"];
    const workStates = ["existing", "new"];

    const { setLocation: use_setLocation } = useMaps();

    function setLocation(place) {
      project.location = use_setLocation(place);
    }

    function submitForm() {
      context.emit("form-submitted", project);
    }

    return { project, workTypes, workStates, setLocation, submitForm };
  }
};
</script>
